import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { getChat, updateChat } from './chat.action';

import { AppError } from 'entities/Errors';
import { Chat } from 'entities/Chat';

interface ChatState {
  action: 'idle' | 'fetch' | 'update';
  status: 'idle' | 'loading' | 'failed' | 'successed';
  error: null | AppError;
  chat: Chat | null;
}

const initialState = {
  action: 'idle',
  status: 'idle',
  error: null,
  chat: null,
} as ChatState;

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    refreshChat(state) {
      state.action = 'idle';
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getChat.pending, (state) => {
        state.action = 'fetch';
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getChat.fulfilled, (state, action) => {
        state.status = 'successed';
        state.chat = action.payload.data;
      })
      .addCase(getChat.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as AppError;
      })
      .addCase(updateChat.pending, (state) => {
        state.action = 'update';
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateChat.fulfilled, (state, action) => {
        state.status = 'successed';
        state.chat = action.payload.data;
      })
      .addCase(updateChat.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as AppError;
      });
  },
});

export const { refreshChat } = chatSlice.actions;

export default chatSlice.reducer;
